// extracted by mini-css-extract-plugin
module.exports = {"theme":"#3370ff","sideBarWidth":"210px","topBarBg":"#f1f3f8","topBarMenuHovor":"rgba(158, 158, 158, 0.2)","topBarMenuActive":"#3370ff","topBarMenuText":"#1e212a","topBarMenuTextActive":"#f4f4f5","leftMenuBg":"#ffffff","leftMenuActive":"#ebf4fd","leftMenuHovor":"rgba(158, 158, 158, 0.2)","leftMenuText":"#1e212a","leftMenuTextActive":"#3370ff"};
    if(module.hot) {
      // 1783323115040
      var cssReload = require("D:/cxy/project/zcy/zcy-dataEase/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  